module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Laptop-0c93b4692d6f5b708576b434892c0c6d.svg";